import { render, staticRenderFns } from "./OdooSyncLog.vue?vue&type=template&id=6784db73"
import script from "./OdooSyncLog.vue?vue&type=script&lang=js"
export * from "./OdooSyncLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports